import { useState, useEffect } from "react";
import "@/App.css";
import { Phone, Mail, MapPin, Clock, Menu, X, ChevronRight, Award, Users, Truck, Shield, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast, Toaster } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Company data
const COMPANY = {
  name: "Özuslu Vinç",
  phone: "0543 618 51 39",
  phoneClean: "05436185139",
  email: "info@ozuslu.com",
  whatsapp: "905436185139",
  slogan: "Düzce'nin Gücü, Yükseklerin Hakimi",
  since: 1998,
  regions: ["Düzce", "İstanbul", "Afyon", "Ereğli"],
  logo: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/oi1as3pj_IMG-20251231-WA0034%281%29.jpg"
};

const SERVICES = [
  {
    icon: Truck,
    title: "Vinç Kiralama",
    description: "35 ton ve 65 ton kapasiteli mobil vinçlerimizle her türlü yük kaldırma işlerinizde yanınızdayız."
  },
  {
    icon: Shield,
    title: "Manitou Hizmeti",
    description: "Zor arazilerde ve dar alanlarda yüksek manevra kabiliyetli manitou ekipmanlarımız hizmetinizde."
  },
  {
    icon: Users,
    title: "Sepetli Platform",
    description: "Yüksek noktalarda güvenli çalışma için sepetli platform araçlarımızla profesyonel destek sağlıyoruz."
  },
  {
    icon: Award,
    title: "7/24 Destek",
    description: "Acil durumlar için 7 gün 24 saat hizmetinizdeyiz. Tek bir arama ile yanınızdayız."
  }
];

const EQUIPMENT = [
  {
    name: "35 Ton Vinç",
    capacity: "35 Ton",
    image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/ufcsg17m_IMG-20260207-WA0052.jpg",
    description: "Orta ölçekli projeler için ideal"
  },
  {
    name: "65 Ton Vinç",
    capacity: "65 Ton",
    image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/b22c8ot7_IMG-20260207-WA0050.jpg",
    description: "Ağır yük taşıma operasyonları için"
  },
  {
    name: "Manitou",
    capacity: "Çok Yönlü",
    image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/m3px1iba_IMG-20260207-WA0054.jpg",
    description: "Dar alanlarda yüksek manevra"
  },
  {
    name: "Sepetli Platform",
    capacity: "Güvenli Erişim",
    image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/i5a9eba7_IMG-20260207-WA0051.jpg",
    description: "Yüksekte güvenli çalışma"
  }
];

const TEAM = [
  { 
    name: "Mesut Uslu", 
    role: "Operatör", 
    experience: "12 Yıl Tecrübe", 
    certs: ["A Sınıfı Operatör Belgesi", "ISG Sertifikası", "Sapan Bağlama", "İlk Yardım", "Yüksekte Çalışma"]
  },
  { 
    name: "Şükrü Uslu", 
    role: "Operatör", 
    experience: "11 Yıl Tecrübe", 
    certs: ["A Sınıfı Operatör Belgesi", "ISG Sertifikası", "Sapan Bağlama", "İlk Yardım", "Yüksekte Çalışma"]
  },
  { 
    name: "Yusuf Uslu", 
    role: "Operatör", 
    experience: "12 Yıl Tecrübe", 
    certs: ["A Sınıfı Operatör Belgesi", "ISG Sertifikası", "Sapan Bağlama", "İlk Yardım", "Yüksekte Çalışma"]
  },
  { 
    name: "Bünyamin Uslu", 
    role: "Operatör", 
    experience: "10 Yıl Tecrübe", 
    certs: ["A Sınıfı Operatör Belgesi", "ISG Sertifikası", "Sapan Bağlama", "İlk Yardım", "Yüksekte Çalışma"]
  },
  { 
    name: "Cihat Uslu", 
    role: "Operatör", 
    experience: "6 Yıl Tecrübe", 
    certs: ["A Sınıfı Operatör Belgesi", "ISG Sertifikası", "Sapan Bağlama", "İlk Yardım", "Yüksekte Çalışma"]
  }
];

// Project gallery images
const PROJECTS = [
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/4f2wsq7f_IMG-20260207-WA0044.jpg", title: "Akçakoca Devlet Hastanesi", location: "Düzce" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/nojppegv_IMG-20260207-WA0039.jpg", title: "Sanayi Tesisi Montajı", location: "Ereğli" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/p70jgu5g_IMG-20260207-WA0035.jpg", title: "Fabrika Çelik Konstrüksiyon", location: "İstanbul" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/4ff8v0aj_IMG-20260207-WA0045.jpg", title: "Vinç Filomuz", location: "Düzce" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/hjjzu5ma_IMG-20260207-WA0036.jpg", title: "Ağır Yük Operasyonu", location: "Afyon" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/2ly9dcvv_IMG-20260207-WA0037.jpg", title: "Çelik Yapı Montajı", location: "Düzce" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/tp51xfef_IMG-20260207-WA0046%281%29.jpg", title: "Şantiye Operasyonu", location: "İstanbul" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/jm1rqdin_IMG-20260207-WA0038.jpg", title: "Gece Çalışması", location: "Ereğli" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/bn3od38j_IMG-20260207-WA0041.jpg", title: "Çelik Konstrüksiyon Montajı", location: "Düzce" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/03hg9g0g_IMG-20260207-WA0042.jpg", title: "Vinç Aracımız", location: "Düzce" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/u8kug1v2_IMG-20260207-WA0043.jpg", title: "Konteyner Taşıma", location: "Ereğli" },
  { image: "https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/9tt7x60f_IMG-20260207-WA0049.jpg", title: "Konut İnşaatı", location: "Düzce" },
];

// Navbar Component
const Navbar = ({ scrolled, mobileMenuOpen, setMobileMenuOpen }) => {
  const navLinks = [
    { href: "#anasayfa", label: "Anasayfa" },
    { href: "#hizmetler", label: "Hizmetler" },
    { href: "#makine-parkuru", label: "Makine Parkuru" },
    { href: "#projelerimiz", label: "Projelerimiz" },
    { href: "#kadro", label: "Kadro" },
    { href: "#hakkimizda", label: "Hakkımızda" },
    { href: "#iletisim", label: "İletişim" }
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`} data-testid="navbar">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#anasayfa" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src={COMPANY.logo} 
              alt="Özuslu Vinç Logo" 
              className="h-14 w-auto"
            />
          </a>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a key={link.href} href={link.href} className="nav-link" data-testid={`nav-${link.label.toLowerCase().replace(/ı/g, 'i').replace(/ü/g, 'u')}`}>
                {link.label}
              </a>
            ))}
          </div>

          {/* Phone & CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a 
              href={`tel:${COMPANY.phoneClean}`} 
              className="flex items-center gap-2 text-primary font-semibold text-sm"
              data-testid="navbar-phone"
            >
              <Phone className="w-4 h-4" />
              <span className="tracking-wide">{COMPANY.phone}</span>
            </a>
            <a 
              href={`https://wa.me/${COMPANY.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm py-2 px-4"
              data-testid="navbar-whatsapp-btn"
            >
              WhatsApp
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden p-2 text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div 
          className="fixed top-0 left-0 w-screen h-screen flex flex-col items-center justify-center overflow-hidden" 
          style={{ backgroundColor: '#0A0A0A', zIndex: 999999 }}
          data-testid="mobile-menu"
        >
          <button 
            className="absolute top-6 right-6 p-2 text-white hover:text-primary z-10"
            onClick={() => setMobileMenuOpen(false)}
            data-testid="mobile-menu-close"
          >
            <X className="w-8 h-8" />
          </button>
          
          {/* Logo in mobile menu */}
          <img 
            src={COMPANY.logo} 
            alt="Özuslu Vinç Logo" 
            className="h-14 w-auto mb-4"
          />
          
          <div className="flex flex-col items-center gap-3">
            {navLinks.map((link) => (
              <a 
                key={link.href} 
                href={link.href} 
                className="text-white hover:text-primary text-base font-medium uppercase tracking-wide py-1"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
          </div>
          
          <div className="flex flex-col gap-3 mt-6 w-56">
            <a 
              href={`tel:${COMPANY.phoneClean}`}
              className="btn-primary text-center text-sm py-3"
              data-testid="mobile-phone-btn"
            >
              <Phone className="w-4 h-4 inline mr-2" />
              Hemen Ara
            </a>
            <a 
              href={`https://wa.me/${COMPANY.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline text-center text-sm py-3"
              data-testid="mobile-whatsapp-btn"
            >
              <MessageCircle className="w-4 h-4 inline mr-2" />
              WhatsApp
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

// Hero Section
const HeroSection = () => {
  return (
    <section id="anasayfa" className="hero-section" data-testid="hero-section">
      <div 
        className="hero-bg"
        style={{ backgroundImage: `url('https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/l363bsdg_IMG-20260207-WA0053.jpg')` }}
      />
      <div className="hero-overlay" />
      
      <div className="relative z-10 container mx-auto px-4 md:px-6 text-center pt-24">
        {/* 7/24 Badge */}
        <div className="badge-24 mb-8 inline-flex animate-pulse-glow" data-testid="badge-247">
          <Clock className="w-4 h-4" />
          <span>7/24 Hizmetinizdeyiz</span>
        </div>

        {/* Big Phone Number */}
        <a 
          href={`tel:${COMPANY.phoneClean}`}
          className="block mb-6"
          data-testid="hero-phone-link"
        >
          <span className="phone-number" data-testid="hero-phone-number">
            {COMPANY.phone}
          </span>
        </a>

        {/* Slogan */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black uppercase tracking-tight text-white mb-6 font-['Oswald']" data-testid="hero-title">
          {COMPANY.slogan}
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-10" data-testid="hero-subtitle">
          {COMPANY.since}'den bu yana {COMPANY.regions.join(", ")} bölgelerinde profesyonel vinç hizmetleri
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a 
            href={`tel:${COMPANY.phoneClean}`}
            className="btn-primary inline-flex items-center justify-center gap-2"
            data-testid="hero-call-btn"
          >
            <Phone className="w-5 h-5" />
            Hemen Ara
          </a>
          <a 
            href={`https://wa.me/${COMPANY.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline inline-flex items-center justify-center gap-2"
            data-testid="hero-whatsapp-btn"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp'tan Yaz
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="mt-20 animate-bounce" data-testid="scroll-indicator">
          <ChevronRight className="w-8 h-8 text-primary rotate-90 mx-auto" />
        </div>
      </div>
    </section>
  );
};

// Services Section
const ServicesSection = () => {
  return (
    <section id="hizmetler" className="py-20 md:py-32 bg-[#0A0A0A]" data-testid="services-section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16">
          <h2 className="section-title" data-testid="services-title">Hizmetlerimiz</h2>
          <p className="text-gray-400 mt-6 max-w-xl">
            Her türlü vinç, manitou ve sepetli platform ihtiyacınızda uzman kadromuzla yanınızdayız.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((service, index) => (
            <div 
              key={index} 
              className="service-card"
              data-testid={`service-card-${index}`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="service-icon">
                <service.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 font-['Oswald'] uppercase tracking-wide">
                {service.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Equipment Section
const EquipmentSection = () => {
  return (
    <section id="makine-parkuru" className="py-20 md:py-32 bg-[#111111]" data-testid="equipment-section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16">
          <h2 className="section-title" data-testid="equipment-title">Makine Parkuru</h2>
          <p className="text-gray-400 mt-6 max-w-xl">
            Modern ve bakımlı ekipman filomuzla en zorlu projelerde bile yanınızdayız.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {EQUIPMENT.map((item, index) => (
            <div 
              key={index} 
              className="equipment-card group"
              data-testid={`equipment-card-${index}`}
            >
              <div className="aspect-[16/10] overflow-hidden relative">
                <img 
                  src={item.image} 
                  alt={item.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="badge-24 mb-3" style={{ background: 'rgba(255,215,0,0.2)' }}>
                    {item.capacity}
                  </div>
                  <h3 className="text-2xl font-bold text-white font-['Oswald'] uppercase tracking-wide">
                    {item.name}
                  </h3>
                  <p className="text-gray-300 text-sm mt-2">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Projects Gallery Section
const ProjectsSection = () => {
  return (
    <section id="projelerimiz" className="py-20 md:py-32 bg-[#0A0A0A]" data-testid="projects-section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16">
          <h2 className="section-title" data-testid="projects-title">Projelerimiz</h2>
          <p className="text-gray-400 mt-6 max-w-xl">
            Tamamladığımız projelerden örnekler. Her projede kalite ve güvenlik önceliğimiz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {PROJECTS.map((project, index) => (
            <div 
              key={index} 
              className="equipment-card group"
              data-testid={`project-card-${index}`}
            >
              <div className="aspect-[4/3] overflow-hidden relative">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-lg font-bold text-white font-['Oswald'] uppercase tracking-wide">
                    {project.title}
                  </h3>
                  <p className="text-primary text-sm mt-1">
                    📍 {project.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Team Section
const TeamSection = () => {
  return (
    <section id="kadro" className="py-20 md:py-32 bg-[#0A0A0A]" data-testid="team-section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16">
          <h2 className="section-title" data-testid="team-title">Profesyonel Kadromuz</h2>
          <p className="text-gray-400 mt-6 max-w-xl">
            Sertifikalı ve deneyimli operatörlerimizle güvenli ve verimli hizmet sunuyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {TEAM.map((member, index) => (
            <div 
              key={index} 
              className="team-card p-5 text-center"
              data-testid={`team-card-${index}`}
            >
              <div className="w-16 h-16 bg-primary/20 rounded-full mx-auto mb-3 flex items-center justify-center border-2 border-primary/50">
                <Users className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-base font-bold text-white font-['Oswald'] uppercase tracking-wide">
                {member.name}
              </h3>
              <p className="text-primary text-sm mt-1 font-medium">
                {member.experience}
              </p>
              <div className="mt-3 pt-3 border-t border-gray-800">
                <div className="flex flex-wrap gap-1 justify-center">
                  {member.certs.map((cert, i) => (
                    <span 
                      key={i} 
                      className="text-[0.6rem] bg-primary/10 text-gray-300 px-2 py-0.5 border border-primary/30"
                    >
                      {cert}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  const currentYear = new Date().getFullYear();
  const yearsInBusiness = currentYear - COMPANY.since;

  return (
    <section id="hakkimizda" className="py-20 md:py-32 bg-[#111111]" data-testid="about-section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="section-title mb-8" data-testid="about-title">Hakkımızda</h2>
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              <span className="text-primary font-bold">{COMPANY.since}</span> yılından bu yana {COMPANY.name} olarak, 
              <span className="text-white font-semibold"> {COMPANY.regions.join(", ")} </span> 
              bölgelerinde vinç kiralama hizmetleri sunmaktayız.
            </p>
            <p className="text-gray-400 leading-relaxed mb-8">
              Uzman kadromuz, modern ekipman filomuz ve rekabetçi fiyatlarımızla müşterilerimizin 
              her türlü yük kaldırma ve taşıma ihtiyaçlarında güvenilir çözüm ortağıyız. 
              İnşaat, sanayi, enerji ve lojistik sektörlerinde binlerce başarılı proje tamamladık.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div data-testid="stat-years">
                <div className="stat-number">{yearsInBusiness}+</div>
                <div className="stat-label">Yıl Tecrübe</div>
              </div>
              <div data-testid="stat-projects">
                <div className="stat-number">5000+</div>
                <div className="stat-label">Proje</div>
              </div>
              <div data-testid="stat-regions">
                <div className="stat-number">{COMPANY.regions.length}</div>
                <div className="stat-label">Bölge</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_c19703ed-f382-4d2f-856f-49a13414efcc/artifacts/m3px1iba_IMG-20260207-WA0054.jpg"
                alt="Özuslu Vinç Operasyonu"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            {/* Accent */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-primary -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${API}/contact`, formData);
      
      // WhatsApp mesajı oluştur
      const whatsappMessage = `🔔 *Yeni Teklif Talebi*%0A%0A👤 *İsim:* ${formData.name}%0A📞 *Telefon:* ${formData.phone}%0A📧 *E-posta:* ${formData.email || 'Belirtilmedi'}%0A%0A💬 *Mesaj:*%0A${formData.message}`;
      
      // WhatsApp'a yönlendir
      window.open(`https://wa.me/${COMPANY.whatsapp}?text=${whatsappMessage}`, '_blank');
      
      toast.success('Mesajınız kaydedildi! WhatsApp üzerinden de iletildi.');
      setFormData({ name: '', phone: '', email: '', message: '' });
    } catch (error) {
      // API hatası olsa bile WhatsApp'a gönder
      const whatsappMessage = `🔔 *Yeni Teklif Talebi*%0A%0A👤 *İsim:* ${formData.name}%0A📞 *Telefon:* ${formData.phone}%0A📧 *E-posta:* ${formData.email || 'Belirtilmedi'}%0A%0A💬 *Mesaj:*%0A${formData.message}`;
      window.open(`https://wa.me/${COMPANY.whatsapp}?text=${whatsappMessage}`, '_blank');
      toast.success('Mesajınız WhatsApp üzerinden iletildi!');
      setFormData({ name: '', phone: '', email: '', message: '' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="iletisim" className="py-20 md:py-32 bg-[#0A0A0A]" data-testid="contact-section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h2 className="section-title mb-8" data-testid="contact-title">İletişim</h2>
            <p className="text-gray-400 mb-10 max-w-lg">
              Vinç, manitou ve sepetli platform ihtiyaçlarınız için hemen bizimle iletişime geçin. 
              7 gün 24 saat hizmetinizdeyiz.
            </p>

            {/* Contact Cards */}
            <div className="space-y-4">
              <a 
                href={`tel:${COMPANY.phoneClean}`}
                className="flex items-center gap-4 p-4 bg-[#1A1A1A] border border-[#333] hover:border-primary transition-colors"
                data-testid="contact-phone-card"
              >
                <div className="w-12 h-12 bg-primary/10 border border-primary flex items-center justify-center">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="text-gray-400 text-sm">Telefon (7/24)</div>
                  <div className="text-white font-bold font-['Oswald'] text-xl tracking-wide">
                    {COMPANY.phone}
                  </div>
                </div>
              </a>

              <a 
                href={`https://wa.me/${COMPANY.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 bg-[#1A1A1A] border border-[#333] hover:border-[#25D366] transition-colors"
                data-testid="contact-whatsapp-card"
              >
                <div className="w-12 h-12 bg-[#25D366]/10 border border-[#25D366] flex items-center justify-center">
                  <MessageCircle className="w-5 h-5 text-[#25D366]" />
                </div>
                <div>
                  <div className="text-gray-400 text-sm">WhatsApp</div>
                  <div className="text-white font-bold font-['Oswald'] text-xl tracking-wide">
                    {COMPANY.phone}
                  </div>
                </div>
              </a>

              <a 
                href={`mailto:${COMPANY.email}`}
                className="flex items-center gap-4 p-4 bg-[#1A1A1A] border border-[#333] hover:border-primary transition-colors"
                data-testid="contact-email-card"
              >
                <div className="w-12 h-12 bg-primary/10 border border-primary flex items-center justify-center">
                  <Mail className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="text-gray-400 text-sm">E-posta</div>
                  <div className="text-white font-bold font-['Oswald'] text-xl tracking-wide">
                    {COMPANY.email}
                  </div>
                </div>
              </a>

              <div className="flex items-center gap-4 p-4 bg-[#1A1A1A] border border-[#333]" data-testid="contact-location-card">
                <div className="w-12 h-12 bg-primary/10 border border-primary flex items-center justify-center">
                  <MapPin className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="text-gray-400 text-sm">Hizmet Bölgeleri</div>
                  <div className="text-white font-bold font-['Oswald'] text-lg tracking-wide">
                    {COMPANY.regions.join(" • ")}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-[#1A1A1A] border border-[#333] p-8">
            <h3 className="text-2xl font-bold text-white font-['Oswald'] uppercase tracking-wide mb-6">
              Teklif Alın
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
              <div>
                <Input
                  type="text"
                  placeholder="Adınız Soyadınız"
                  className="form-input w-full bg-[#262626] border-[#333] text-white placeholder:text-gray-500"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  data-testid="contact-form-name"
                />
              </div>
              <div>
                <Input
                  type="tel"
                  placeholder="Telefon Numaranız"
                  className="form-input w-full bg-[#262626] border-[#333] text-white placeholder:text-gray-500"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  required
                  data-testid="contact-form-phone"
                />
              </div>
              <div>
                <Input
                  type="email"
                  placeholder="E-posta Adresiniz"
                  className="form-input w-full bg-[#262626] border-[#333] text-white placeholder:text-gray-500"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  data-testid="contact-form-email"
                />
              </div>
              <div>
                <Textarea
                  placeholder="Mesajınız (Hangi hizmete ihtiyacınız var?)"
                  className="form-input w-full bg-[#262626] border-[#333] text-white placeholder:text-gray-500 min-h-[120px]"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  required
                  data-testid="contact-form-message"
                />
              </div>
              <Button 
                type="submit" 
                className="btn-primary w-full"
                disabled={loading}
                data-testid="contact-form-submit"
              >
                {loading ? 'Gönderiliyor...' : 'Mesaj Gönder'}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  return (
    <footer className="footer py-12" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <img 
              src={COMPANY.logo} 
              alt="Özuslu Vinç" 
              className="h-12 w-auto"
            />
            <div>
              <div className="text-white font-bold font-['Oswald'] uppercase tracking-wide">
                {COMPANY.name}
              </div>
              <div className="text-gray-500 text-sm">
                {COMPANY.since}'den beri hizmetinizde
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-6">
            <a 
              href={`tel:${COMPANY.phoneClean}`}
              className="text-primary hover:text-yellow-400 transition-colors font-bold"
              data-testid="footer-phone"
            >
              <Phone className="w-5 h-5 inline mr-2" />
              {COMPANY.phone}
            </a>
            <a 
              href={`mailto:${COMPANY.email}`}
              className="text-gray-400 hover:text-white transition-colors"
              data-testid="footer-email"
            >
              <Mail className="w-5 h-5 inline mr-2" />
              {COMPANY.email}
            </a>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-[#262626] text-center text-gray-500 text-sm">
          © {new Date().getFullYear()} {COMPANY.name}. Tüm hakları saklıdır.
        </div>
      </div>
    </footer>
  );
};

// WhatsApp Float Button
const WhatsAppFloat = () => {
  return (
    <a 
      href={`https://wa.me/${COMPANY.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      data-testid="whatsapp-float"
      aria-label="WhatsApp ile iletişime geç"
    >
      <MessageCircle className="w-7 h-7 text-white" />
    </a>
  );
};

// Main App Component
function App() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App" data-testid="app-container">
      <Toaster position="top-right" richColors />
      <div className="grain-overlay" />
      
      <Navbar 
        scrolled={scrolled} 
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      
      <main>
        <HeroSection />
        <ServicesSection />
        <EquipmentSection />
        <ProjectsSection />
        <TeamSection />
        <AboutSection />
        <ContactSection />
      </main>
      
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
